import { registerImages, Source } from '@bonanza-social/moonlight';
import images from './images';

declare global {
  interface RegisteredImages {
    inviteFriends: Record<keyof typeof images, Source>;
  }
}

registerImages('inviteFriends', images);
